// FR UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Appartements et hôtels',
  'site.currency': 'Devise',
  'site.language': 'Langue',
  'site.currencySelector': 'Sélecteur de devise',
  'site.languageSelector': 'Sélecteur de langue',
  'site.menu': 'Menu',
  'site.signIn': 'Se connecter',
  'site.signOut': 'Se déconnecter',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Ouvrir le menu',
  'site.footer.copyright': 'Tous droits réservés.',
  'site.footer.manageBooking': 'Gérer ma réservation',
  'site.footer.terms': 'Conditions générales',
  'site.footer.privacy': 'Politique de confidentialité',
  'site.trust.bestPrice': 'Meilleur prix garanti',
  'site.trust.bestPriceDesc': 'Bénéficiez des meilleurs tarifs.',
  'site.trust.flexibleBooking': 'Réservation flexible',
  'site.trust.flexibleBookingDesc': 'Modifications et annulations faciles.',
  'site.trust.securePayments': 'Paiements sécurisés',
  'site.trust.securePaymentsDesc': 'Paiement fiable et sécurisé.',
  'site.trust.localSupport': 'Assistance locale',
  'site.trust.localSupportDesc': 'Nous sommes là pour vous aider à tout moment.',
  'home.heroTitle': 'Trouvez votre séjour idéal',
  'home.inAustralia': 'en Australie',
  'home.heroSubtitle': 'Appartements et hôtels pour tous les types de séjour',
  'home.errorLoading': "Les établissements n'ont pas pu être chargés.",
  'home.noPropertiesTitle': 'Aucun établissement disponible pour le moment.',
  'home.noPropertiesDescription':
    'Essayez de rechercher une destination pour découvrir les séjours disponibles.',
  'home.exploreStays': 'Explorer les séjours',
  'home.property': 'établissement',
  'home.property_one': 'établissement',
  'home.property_other': 'établissements',
  'home.properties': 'établissements',
  'home.foundInAustralia': 'trouvé(s) en Australie',
  'search.errorLoading': "La disponibilité n'a pas pu être chargée. Veuillez réessayer.",
  'search.noResults': 'Aucun établissement ne correspond à vos critères.',
  'search.mapFollow': 'Rechercher en déplaçant la carte',
  'search.chooseLocationTitle': 'Choisissez un lieu',
  'search.chooseLocationDescription':
    'Sélectionnez une destination avant de rechercher les séjours disponibles.',
  'search.chooseDatesTitle': 'Choisissez vos dates',
  'search.pastCheckIn': "L'arrivée ne peut pas être dans le passé.",
  'search.checkOutAfterCheckIn': "Le départ doit être après l'arrivée.",
  'search.property': 'établissement',
  'search.property_one': 'établissement',
  'search.property_other': 'établissements',
  'search.properties': 'établissements',
  'search.found': 'trouvé(s)',
  'widget.where': 'Où',
  'widget.location': 'Lieu',
  'widget.checkInOut': 'Arrivée / Départ',
  'widget.guests': 'Invités',
  'widget.rooms': 'Chambres',
  'widget.promoCode': 'Code promo',
  'widget.promoPlaceholderCompact': 'Ajouter un code (optionnel)',
  'widget.promoPlaceholder': 'Optionnel',
  'widget.search': 'Rechercher',
  'widget.update': 'Mettre à jour',
  'widget.adult': 'Adulte',
  'widget.adults': 'Adultes',
  'widget.child': 'Enfant',
  'widget.children': 'Enfants',
  'widget.decreaseAdults': 'Diminuer les adultes',
  'widget.increaseAdults': 'Augmenter les adultes',
  'widget.decreaseChildren': 'Diminuer les enfants',
  'widget.increaseChildren': 'Augmenter les enfants',
  'widget.room': 'Chambre',
  'widget.adultOption': '{count} adultes',
  'widget.adultOption_one': '{count} adulte',
  'widget.adultOption_other': '{count} adultes',
  'widget.childOption': '{count} enfants',
  'widget.childOption_one': '{count} enfant',
  'widget.childOption_other': '{count} enfants',
  'widget.roomOption': '{count} chambres',
  'widget.roomOption_one': '{count} chambre',
  'widget.roomOption_other': '{count} chambres',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': "Les lieux n'ont pas pu être chargés. Veuillez réessayer.",
  'widget.searchAria': 'Rechercher la disponibilité',
  'widget.dateErrorRequired': "Veuillez sélectionner l'arrivée et le départ.",
  'widget.dateErrorPast': "L'arrivée ne peut pas être dans le passé.",
  'widget.dateErrorRange': "Le départ doit être après l'arrivée.",
  'widget.dateRange.placeholder': "Sélectionnez les dates d'arrivée et de départ",
  'widget.dateRange.selectCheckout': 'Sélectionnez le départ',
  'widget.dateRange.aria.checkIn': 'Arrivée',
  'widget.dateRange.aria.checkOut': 'Départ',
  'widget.dateRange.aria.picker': "Sélecteur de dates d'arrivée et de départ",
  'widget.dateRange.previousMonth': 'Mois précédent',
  'widget.dateRange.nextMonth': 'Mois suivant',
  'widget.dateRange.selectCheckIn': "Sélectionnez la date d'arrivée",
  'widget.dateRange.selectCheckOut': 'Sélectionnez la date de départ',
  'widget.dateRange.resetToday': "Réinitialiser à aujourd'hui",
  'widget.dateRange.done': 'Terminé',
  'property.heroAlt': 'Établissement',
  'property.fallbackName': 'Établissement sélectionné par {site}',
  'property.chooseRoom': 'Choisissez votre chambre',
  'property.filterBy': 'Filtrer par :',
  'property.filterAll': 'Toutes les chambres',
  'property.filterStudios': 'Studios',
  'property.filter1Bed': '1 chambre',
  'property.filter2Bed': '2 chambres',
  'property.filterApartments': 'Appartements',
  'property.sortBy': 'Trier par :',
  'property.sortRecommended': 'Recommandé',
  'property.sortPriceLow': 'Prix : croissant',
  'property.sortPriceHigh': 'Prix : décroissant',
  'property.errorLoading': "La disponibilité n'a pas pu être chargée. Veuillez réessayer.",
  'property.noRooms': 'Aucune chambre disponible',
  'property.noRoomsDescription': "Essayez d'autres dates ou d'autres invités.",
  'property.totalForNights': 'Total pour {nights} nuits',
  'property.perNight': 'par nuit',
  'property.night': 'nuit',
  'property.night_one': 'nuit',
  'property.night_other': 'nuits',
  'property.nights': 'nuits',
  'property.freeCancellation': 'Annulation gratuite',
  'property.selectRoom': 'Sélectionner la chambre',
  'property.selected': 'Sélectionnée',
  'property.continue': 'Continuer',
  'property.previousPhoto': 'Photo précédente',
  'property.nextPhoto': 'Photo suivante',
  'property.addToWishlist': 'Ajouter à la liste de souhaits',
  'property.popularChoice': 'Choix populaire',
  'property.showMore': 'Voir plus',
  'property.showLess': 'Voir moins',
  'property.maxOccupancy': 'Occupation max :',
  'property.size': 'Taille :',
  'property.bedType': 'Type de lit :',
  'property.roomAmenities': 'Équipements de la chambre',
  'property.showMoreAmenities': '+{count} autres',
  'property.guests': 'invités',
  'property.adults': 'Adultes',
  'property.children': 'Enfants',
  'property.onlyRoomsLeft': 'Plus que {count} chambres disponibles',
  'property.onlyRoomsLeft_one': 'Plus que {count} chambre disponible',
  'property.onlyRoomsLeft_other': 'Plus que {count} chambres disponibles',
  'property.lastBookedMinutes': 'Dernière réservation il y a {count} minutes',
  'property.lastBookedMinutes_one': 'Dernière réservation il y a {count} minute',
  'property.lastBookedMinutes_other': 'Dernière réservation il y a {count} minutes',
  'property.lastBookedHours': 'Dernière réservation il y a {count} heures',
  'property.lastBookedHours_one': 'Dernière réservation il y a {count} heure',
  'property.lastBookedHours_other': 'Dernière réservation il y a {count} heures',
  'property.lastBookedDays': 'Dernière réservation il y a {count} jours',
  'property.lastBookedDays_one': 'Dernière réservation il y a {count} jour',
  'property.lastBookedDays_other': 'Dernière réservation il y a {count} jours',
  'property.checkInTime': 'Arrivée {time}',
  'property.checkOutTime': 'Départ {time}',
  'property.compare': 'Comparer',
  'property.taxesIncluded': 'par nuit taxes et frais inclus',
  'property.chooseRate': 'Choisissez votre tarif',
  'property.yourSelection': 'Votre sélection',
  'property.aboutRoom': 'À propos de cette chambre',
  'property.roomDetails': 'Détails de la chambre',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Retour aux chambres',
  'property.standardRate': 'Tarif standard',
  'property.noPromotion': 'Aucune promotion disponible pour ce tarif.',
  'property.youSave': 'Vous économisez ({percent}% de remise) - {amount}',
  'property.inclusions': 'Inclus :',
  'property.viewAllPhotos': 'Voir toutes les photos',
  'property.seeOnMap': 'Voir sur la carte',
  'room.perNight': 'nuit',
  'room.sleeps': 'Couchages',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'disponible',
  'room.select': 'Sélectionner',
  'room.selected': 'Sélectionnée',
  'card.viewAvailability': 'Voir la disponibilité',
  'card.from': 'À partir de',
  'card.night': 'nuit',
  'card.checkAvailability': 'Vérifier la disponibilité',
  'card.saveToFavourites': 'Enregistrer dans les favoris',
  'card.ratingExcellent': 'Excellent',
  'card.ratingVeryGood': 'Très bien',
  'card.ratingGood': 'Bien',
  'card.ratingGuest': 'Note des clients',
  'guest.stepChooseRoom': 'Choisir la chambre',
  'guest.stepGuestDetails': 'Coordonnées',
  'guest.stepPayment': 'Paiement',
  'guest.stepConfirmation': 'Confirmation',
  'guest.title': 'Saisir les coordonnées',
  'guest.subtitle': 'Veuillez fournir vos informations.',
  'guest.firstName': 'Prénom',
  'guest.lastName': 'Nom',
  'guest.email': 'E-mail',
  'guest.emailHint': 'La confirmation de réservation sera envoyée à cet e-mail.',
  'guest.country': 'Pays',
  'guest.selectCountry': 'Sélectionner un pays',
  'guest.searchCountry': 'Rechercher un pays…',
  'guest.loadingCountries': 'Chargement des pays…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Code postal',
  'guest.phone': 'Téléphone',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Saisir le numéro de téléphone',
  'guest.address': 'Adresse',
  'guest.city': 'Ville',
  'guest.specialRequests': 'Demandes particulières (optionnel)',
  'guest.specialRequestsPlaceholder': 'Des demandes particulières ?',
  'guest.termsPrefix': "En finalisant cette réservation, j'accepte les",
  'guest.terms': 'Conditions générales',
  'guest.termsAnd': 'et',
  'guest.privacy': 'Politique de confidentialité',
  'guest.termsSuffix': ", et j'accepte les conditions de réservation.",
  'guest.marketingOptOut': 'Je ne souhaite pas recevoir de messages marketing.',
  'guest.cardVerify':
    'Une vérification temporaire de 1 {currency} sera effectuée sur votre carte. Vous ne serez pas débité maintenant.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'Le paiement sera effectué sur place.',
  'guest.noRoomsSelected': 'Aucune chambre sélectionnée.',
  'guest.noPropertySelected': 'Aucun établissement sélectionné.',
  'guest.paymentStillLoading':
    'Les options de paiement sont encore en chargement. Veuillez réessayer dans un instant.',
  'guest.submitProcessing': 'Traitement…',
  'guest.submitVerifyCard': 'Vérifier la carte et confirmer la réservation',
  'guest.submitConfirm': 'Confirmer la réservation',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Paiement',
  'payment.method': 'Mode de paiement',
  'payment.cardDetailsHint':
    'Saisissez vos coordonnées bancaires en toute sécurité ci-dessous. Elles sont tokenisées et ne transitent jamais par nos serveurs.',
  'payment.loadingForm': 'Chargement du formulaire de paiement…',
  'payment.formUnavailable': 'Formulaire de paiement indisponible.',
  'payment.acceptTerms': "J'accepte les conditions générales et la politique d'annulation.",
  'payment.payNow': 'Payer maintenant',
  'payment.processing': 'Traitement…',
  'payment.noRoomsSelected': 'Aucune chambre sélectionnée.',
  'payment.redirecting': 'Redirection vers la page de paiement sécurisée…',
  'payment.notConfigured': "Quickstream n'est pas configuré pour cet établissement.",
  'payment.noScript':
    "Le service de paiement Quickstream n'a pas pu être chargé. Veuillez actualiser la page.",
  'payment.formNotLoaded':
    "Le formulaire de paiement n'a pas été chargé. Veuillez actualiser la page.",
  'payment.cardDetails': 'Le paiement a échoué. Veuillez vérifier vos coordonnées bancaires.',
  'payment.tokenizationFailed': 'La tokenisation de la carte a échoué. Veuillez réessayer.',
  'payment.failed': 'Le paiement a échoué.',
  'payment.statusResult': 'Statut du paiement : {status}. Veuillez réessayer.',
  'confirmation.loading': 'Chargement de votre réservation…',
  'confirmation.notFound': 'Réservation introuvable. Vérifiez votre référence et réessayez.',
  'confirmation.errorGeneric':
    "Votre réservation n'a pas pu être confirmée. Veuillez contacter le support.",
  'confirmation.errorLoadDetails': 'Impossible de charger les détails de la réservation.',
  'confirmation.couldNotComplete': "Nous n'avons pas pu finaliser votre paiement",
  'confirmation.startNew': 'Commencer une nouvelle réservation',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': 'Session de paiement introuvable. Veuillez contacter le support.',
  'confirmation.paymentStateInvalid':
    "Le paiement n'est pas dans un état valide pour être finalisé. Veuillez recommencer.",
  'confirmation.paymentFailedDeclined':
    "Votre paiement n'a pas pu être finalisé. Veuillez vérifier vos coordonnées bancaires et réessayer, ou utilisez un autre mode de paiement.",
  'confirmation.paymentTimeout': 'Le paiement a pris trop de temps. Veuillez réessayer.',
  'confirmation.paymentGatewayUnavailable':
    'Le système de paiement est temporairement indisponible. Veuillez réessayer dans quelques instants.',
  'confirmation.paymentUnknown': "Le paiement n'a pas pu être confirmé : {message}.",
  'confirmation.paymentGenericError':
    "Le paiement n'a pas pu être confirmé. Veuillez réessayer ou contacter le support.",
  'summary.title': 'Récapitulatif de votre réservation',
  'summary.yourBooking': 'Récapitulatif de votre réservation',
  'summary.noRoomsSelected': 'Aucune chambre sélectionnée pour le moment.',
  'summary.checkIn': 'ARRIVÉE',
  'summary.checkOut': 'DÉPART',
  'summary.lengthOfStay': 'Durée du séjour',
  'summary.guests': 'Invités',
  'summary.nights': '{nights} nuits',
  'summary.nights_one': '{nights} nuit',
  'summary.nights_other': '{nights} nuits',
  'summary.totalForNights': 'Total pour {nights} nuits',
  'summary.includingTaxes': 'Taxes et frais inclus',
  'summary.discount': 'Économisez {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'Réservation confirmée !',
  'detail.received': 'Réservation reçue',
  'detail.referenceIntro': 'Votre référence de réservation est',
  'detail.reservationId': 'ID de réservation :',
  'detail.processing':
    'Votre réservation est en cours de traitement. Vous recevrez un e-mail de confirmation une fois le paiement confirmé.',
  'detail.guest': 'Client',
  'detail.rooms': 'Chambres',
  'detail.night': 'nuit',
  'detail.nights': 'nuits',
  'detail.adult': 'adulte',
  'detail.adults': 'adultes',
  'detail.child': 'enfant',
  'detail.infant': 'bébé',
  'detail.priceBreakdown': 'Détail du prix',
  'detail.subtotal': 'Sous-total',
  'detail.taxes': 'Taxes',
  'detail.fees': 'Frais',
  'detail.discounts': 'Remises',
  'detail.surcharge': 'Frais de carte',
  'detail.grandTotal': 'Total',
  'priceBreakdown.roomSubtotal': 'Sous-total des chambres',
  'priceBreakdown.total': 'Total',
  'detail.deposit': 'Acompte',
  'detail.depositDueBy': 'à payer avant',
  'detail.arrival': 'arrivée',
  'detail.specialRequests': 'Demandes particulières',
  'detail.backToHome': "Retour à l'accueil",
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Réessayer',
  'shared.close': 'Fermer',
  'shared.back': 'Retour',
  'shared.previous': 'Précédent',
  'shared.next': 'Suivant',
  'validation.firstNameRequired': 'Le prénom est requis',
  'validation.lastNameRequired': 'Le nom est requis',
  'validation.emailRequired': 'Une adresse e-mail valide est requise',
  'validation.phoneRequired': 'Le numéro de téléphone est requis',
  'validation.addressRequired': "L'adresse est requise",
  'validation.cityRequired': 'La ville est requise',
  'validation.countryRequired': 'Le pays est requis',
  'validation.postalCodeRequired': 'Le code postal est requis',
  'error.pmsUnavailable':
    "Désolé, cette chambre n'est plus disponible pour les dates sélectionnées. Veuillez revenir en arrière et choisir d'autres dates ou une autre chambre.",
  'error.pmsSyncError':
    "Nous n'avons pas pu nous connecter au système de l'établissement. Veuillez réessayer dans quelques instants.",
  'error.paymentNotConfigured':
    "Le paiement n'est pas configuré pour cet établissement. Veuillez choisir un autre établissement ou contacter le support.",
  'error.paymentStartFailed':
    "Une erreur s'est produite lors du démarrage du paiement. Veuillez réessayer.",
  'error.bookingFailed': 'La réservation a échoué. Veuillez réessayer.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Réservez votre séjour',
  'site.title.suffix': 'Appartements et hôtels',
  'site.title.home': 'Accueil',
  'site.title.search': 'Recherche',
  'site.title.property': 'Établissement',
  'site.title.room': 'Chambre',
  'site.title.guestDetails': 'Coordonnées',
  'site.title.payment': 'Paiement',
  'site.title.confirmation': 'Réservation confirmée',
  'site.title.bookingLookup': 'Trouver ma réservation',
  'site.title.bookingDetails': 'Détails de la réservation',
  'site.title.cancellation': 'Annuler la réservation',
  'site.title.reservationDetail': 'Détails de la réservation',
  'site.title.signIn': 'Connexion',
  'site.title.signUp': 'Inscription',
  'site.title.notFound': 'Page non trouvée',
  'notFound.title': 'Page non trouvée',
  'notFound.message': "La page que vous recherchez n'existe pas.",
  'notFound.backHome': "Retour à l'accueil",
  'home.heroAlt': "Skyline d'une ville australienne",
  'home.featuredProperties': 'Établissements en vedette',
  'home.popularDestinations': 'Destinations populaires',
  'common.reviews': '{count} avis',
  'common.reviews_one': '{count} avis',
  'common.reviews_other': '{count} avis',
  'common.loading': 'Chargement',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'sur',
  'common.select': 'Sélectionner…',
  'common.search': 'Rechercher…',
  'common.selectLocation': 'Sélectionnez un lieu',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'Aucune option disponible',
  'common.code': 'Code',
  'common.searchCode': 'Rechercher un code…',
  'filter.title': 'Filtres',
  'filter.price': 'Prix',
  'filter.priceMinimum': 'Minimum',
  'filter.priceMaximum': 'Maximum',
  'filter.priceMinPlaceholder': '0 $',
  'filter.priceMaxPlaceholder': '500+ $',
  'filter.propertyType': "Type d'établissement",
  'filter.propertyType.hotel': 'Hôtel',
  'filter.propertyType.apartment': 'Appartement',
  'filter.propertyType.resort': 'Villégiature',
  'filter.amenities': 'Équipements',
  'filter.amenity.pool': 'Piscine',
  'filter.amenity.parking': 'Parking',
  'filter.amenity.breakfast': 'Petit-déjeuner inclus',
  'filter.rating': 'Note',
  'filter.rating.any': 'Toutes les notes',
  'filter.rating.5': '5 étoiles',
  'filter.rating.4': '4 étoiles et plus',
  'filter.rating.3': '3 étoiles et plus',
  'filter.more': 'Plus',
  'filter.more.freeCancellation': 'Annulation gratuite',
  'filter.more.payAtProperty': 'Payer sur place',
  'filter.clear': 'Effacer',
  'filter.apply': 'Appliquer les filtres',
  'card.reviews_one': 'avis',
  'card.reviews_other': 'avis',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'De 0 à 12 ans',
  'auth.orContinueWith': 'Ou continuer avec',
  'auth.signIn.title': 'Connectez-vous à votre compte',
  'auth.signIn.subtitle':
    'Bienvenue ! Connectez-vous pour gérer vos réservations, consulter vos séjours et accéder à des offres exclusives.',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'Saisissez votre adresse e-mail',
  'auth.emailRequired': "L'adresse e-mail est requise.",
  'auth.emailInvalid': 'Veuillez saisir une adresse e-mail valide.',
  'auth.password': 'Mot de passe',
  'auth.passwordPlaceholder': 'Saisissez votre mot de passe',
  'auth.createPasswordPlaceholder': 'Créez un mot de passe',
  'auth.passwordRequired': 'Le mot de passe est requis.',
  'auth.passwordMinLength': 'Le mot de passe doit contenir au moins {min} caractères.',
  'auth.passwordPattern': 'Le mot de passe doit contenir des lettres et des chiffres.',
  'auth.passwordHint':
    'Utilisez au moins {min} caractères avec un mélange de lettres, de chiffres et de symboles.',
  'auth.showPassword': 'Afficher le mot de passe',
  'auth.hidePassword': 'Masquer le mot de passe',
  'auth.keepSignedIn': 'Rester connecté',
  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Se connecter',
  'auth.signingIn': 'Connexion en cours…',
  'auth.signInError': 'La connexion a échoué. Veuillez réessayer.',
  'auth.googleError': 'La connexion Google a échoué.',
  'auth.noAccount': "Vous n'avez pas de compte ?",
  'auth.createAccount': 'Créer un compte',
  'auth.signUp.title': 'Créez votre compte',
  'auth.signUp.subtitle':
    "Rejoignez {site} pour gérer vos réservations, enregistrer vos établissements favoris et bénéficier d'offres exclusives.",
  'auth.firstName': 'Prénom',
  'auth.firstNamePlaceholder': 'Saisissez votre prénom',
  'auth.firstNameRequired': 'Le prénom est requis.',
  'auth.lastName': 'Nom',
  'auth.lastNamePlaceholder': 'Saisissez votre nom',
  'auth.lastNameRequired': 'Le nom est requis.',
  'auth.mobile': 'Numéro de mobile',
  'auth.mobilePlaceholder': 'Saisissez votre numéro de mobile',
  'auth.dialingCode': 'Indicatif téléphonique',
  'auth.mobileRequired': 'Le numéro de mobile est requis.',
  'auth.mobileInvalid': 'Veuillez saisir un numéro de mobile valide.',
  'auth.confirmPassword': 'Confirmer le mot de passe',
  'auth.confirmPasswordPlaceholder': 'Confirmez votre mot de passe',
  'auth.termsAgree': "J'accepte les",
  'auth.termsRequired':
    'Vous devez accepter les Conditions générales et la Politique de confidentialité.',
  'auth.marketingConsent':
    'Je souhaite recevoir des offres exclusives et des inspirations voyage de {site}',
  'auth.signUpError': "Le compte n'a pas pu être créé. Veuillez réessayer.",
  'auth.signUp': "S'inscrire",
  'auth.creatingAccount': 'Création du compte en cours…',
  'auth.createAccountButton': 'Créer un compte',
  'auth.alreadyHaveAccount': 'Vous avez déjà un compte ?',
  'auth.passwordMismatch': 'Les mots de passe ne correspondent pas.',
  'pricing.title': 'Récapitulatif des prix',
  'pricing.noRoomsSelected':
    'Aucune chambre sélectionnée. Veuillez revenir en arrière et sélectionner des chambres.',
  'pricing.backToAvailability': 'Retour à la disponibilité',
  'pricing.continue': 'Continuer vers les coordonnées',
  'property.youSavePercent': 'Vous économisez ({percent}% de remise)',
  'property.includingTaxesFees': '(taxes et frais inclus)',
  'map.zoomIn': 'Zoomer',
  'map.zoomOut': 'Dézoomer',
  'map.viewFullMap': 'Voir la carte en plein écran',
  'booking.progress': 'Avancement de la réservation',
  'reservationDetail.resetAria': "Réinitialiser l'état de la réservation",
  'bookingLookup.title': 'Trouver ma réservation',
  'bookingLookup.description':
    'Saisissez votre numéro de réservation et votre e-mail pour consulter, modifier ou annuler votre réservation.',
  'bookingLookup.bookingReference': 'Numéro de réservation',
  'bookingLookup.placeholder': 'ex. SYD-260815-0001',
  'bookingLookup.lookingUp': 'Recherche en cours…',
  'bookingLookup.findBooking': 'Trouver ma réservation',
  'bookingLookup.notFound':
    'Réservation introuvable. Essayez BK-2026-001, alex.morgan@example.com et Morgan.',
  'cancellation.title': 'Annuler la réservation',
  'cancellation.property': 'Établissement',
  'cancellation.details': "Détails de l'annulation",
  'cancellation.penalty': "Pénalité d'annulation",
  'cancellation.refund': 'Montant du remboursement',
  'cancellation.totalPaid': 'Total payé :',
  'cancellation.reasonLabel': "Motif de l'annulation (optionnel)",
  'cancellation.understand': 'Je comprends que cette action est irréversible.',
  'cancellation.cancelledDemo':
    'Votre réservation a été annulée dans cette démo. Montant du remboursement : {{refundAmount}}.',
  'cancellation.confirm': "Confirmer l'annulation",
  'cancellation.notFound': 'Réservation introuvable.',
  'bookingDetails.title': 'Détails de la réservation',
  'bookingDetails.notFound': 'Réservation introuvable.',
  'bookingDetails.checkIn': 'Arrivée :',
  'bookingDetails.checkOut': 'Départ :',
  'bookingDetails.rooms': 'Chambres',
  'bookingDetails.guest': 'Client',
  'bookingDetails.freeCancellationUntil': "Annulation gratuite jusqu'au {date}",
  'bookingDetails.total': 'Total :',
  'reservationDetail.loading': 'Chargement de votre réservation…',
  'reservationDetail.noReference': 'Aucun numéro de réservation fourni.',
  'reservationDetail.loadError': 'Impossible de charger les détails de la réservation.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'Chargement des lieux…',
  'common.couldNotLoadLocations': 'Impossible de charger les lieux',
  'common.searchLocationPlaceholder': 'Rechercher un pays, une ville ou un établissement',
  'common.collapse': 'Réduire',
  'common.expand': 'Développer',
  'map.loadingGoogle': 'Chargement de Google Maps…',
  'map.errorGoogle': 'Échec du chargement de Google Maps',
  'map.errorMap': 'Échec du chargement de la carte.',
  'map.greatLocation': 'Emplacement idéal',
  'home.trust.secureBooking': 'Réservation sécurisée',
  'home.trust.secureBookingDesc': 'Vos informations sont en sécurité avec nous.',
  'home.trust.bestPrice': 'Meilleur prix garanti',
  'home.trust.bestPriceDesc': "Vous avez trouvé un prix plus bas ? Nous l'égalerons.",
  'home.trust.localSupport': 'Assistance 24/7',
  'home.trust.localSupportDesc': 'Nous sommes là pour vous aider à tout moment.',
  'home.trust.flexibleBooking': 'Options flexibles',
  'home.trust.flexibleBookingDesc': 'Annulation gratuite sur certains tarifs.',
  'promotion.memberPromo': 'Promo membre',
  'promotion.save': 'Économiser',
  'property.memberRate': 'Tarif membre',
  'property.hideAmenities': 'Masquer les équipements',
  'property.showAllAmenities': 'Voir tous les équipements',
  'property.chooseRatePromo':
    'Choisissez votre tarif préféré - Les tarifs membres offrent des économies exclusives !',
  'roomRate.stepChooseStay': 'Choisissez votre séjour',
  'roomRate.stepCheckout': 'Paiement',
  'roomRate.stepConfirmation': 'Confirmation',
  'roomRate.membersSaveUpTo': 'Les membres économisent jusqu’à {percent} %',
  'roomRate.membersSaveMore': 'Les membres économisent plus',
  'roomRate.memberSignInHint':
    'Connectez-vous ou rejoignez gratuitement lors du paiement pour débloquer les tarifs membres.',
  'roomRate.from': 'À PARTIR DE',
  'roomRate.perNightSuffix': '/ nuit',
  'roomRate.nonMemberFrom': 'Tarif non-membre à partir de {price}',
  'roomRate.taxesIncluded': 'Tarifs taxes et frais inclus',
  'roomRate.taxesExcluded': 'Tarifs hors taxes et frais',
  'roomRate.inclTaxes': 'taxes et frais inclus',
  'roomRate.exclTaxes': 'hors taxes et frais',
  'roomRate.includesTaxes': 'Taxes et frais inclus',
  'roomRate.excludesTaxes': 'Hors taxes et frais',
  'roomRate.bookNow': 'Réserver',
  'roomRate.selectRate': 'Choisir ce tarif',
  'roomRate.bestValue': 'Meilleure offre',
  'roomRate.onlyLeftAtPrice': 'Plus que {count} à ce prix',
  'roomRate.fullDetails': 'Tous les détails de la chambre',
  'roomRate.loadMoreRates': 'Voir plus de tarifs',
  'roomRate.showLessRates': 'Voir moins de tarifs',
  'roomRate.vsNonMemberTotal': 'vs tarif non-membre de {total}',
  'roomRate.youSave': 'Vous économisez {amount} ({percent} % de remise)',
  'roomRate.totalForNights': '{total} au total • {nights} nuits',
  'roomRate.nightTimes': '{nights} nuits × {perNight}',
  'roomRate.totalLine': '{total} au total • {taxNote}',
  'roomRate.notMemberYet':
    'Pas encore membre ? Rejoignez lors du paiement — le tarif membre s’applique quand même.',
  'roomRate.promoApplied': 'Promo {code} appliquée',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': 'Voir les autres types de chambres',
  'roomRate.view': 'Voir',
  'roomRate.freeCancelUntil': 'Annulation gratuite jusqu’au {date}',
  'roomRate.upsell': 'Alternative recommandée',
  'roomRate.roomsIncluded': '{count} chambres incluses',
  'roomRate.nightlyBreakdown': 'Prix par nuit',
  'roomRate.previousRate': 'Tarif précédent',
  'roomRate.nextRate': 'Tarif suivant',
  'card.discount': '-{percent}% de remise',
  'gallery.imageAlt': '{title} vue {current} sur {total}',
  'gallery.thumbnailAlt': 'Aller à la vue {current} sur {total}',
  'gallery.previewAlt': 'Aperçu {title}',
  'detail.night_one': 'nuit',
  'detail.night_other': 'nuits',
  'detail.adult_one': 'adulte',
  'detail.adult_other': 'adultes',
  'detail.child_one': 'enfant',
  'detail.child_other': 'enfants',
  'detail.infant_one': 'bébé',
  'detail.infant_other': 'bébés',
} as const;
